<template>
  <v-container grid-list-xs fluid>
    <!-- DATA TABLE -->
    <v-card class="layout row wrap shadow pa-3 mt-3">
      <div class="flex-row justify-space-between align-center grey lighten-4">
        <strong class="title_label pl-2" slot="activator">
          <span>{{ $t(label) }}</span>
        </strong>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              v-on="on"
              color="grey darken-2"
              class="ma-0 mr-2 pa-0"
              @click="printTable(true)"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
          </template>
          <span>Excel Export</span>
        </v-tooltip>
      </div>

      <v-flex xs12>
        <v-autocomplete
          multiple
          clearable
          return-object
          item-value="id"
          item-text="name"
          :items="programAreas"
          v-model="selectedAreas"
          :placeholder="$t(type)"
        />
      </v-flex>

      <v-data-table
        ref="tbl"
        class="flex xs12"
        :headers="headers"
        :loading="loading"
        :items="filteredItems"
        :rows-per-page-items="per_page"
      >
        <template v-slot:items="{ item }">
          <tr>
            <td class="font-weight-bold">
              <router-link :to="`/CSOs/${item.id}`">
                {{ item.name }}
              </router-link>
            </td>
            <td
              :key="header.value"
              class="font-weight-bold"
              v-for="header in filteredHeaders"
            >
              {{ header.computed(item) }}
            </td>
          </tr>
        </template>
        <template slot="footer">
          <tr>
            <td class="font-weight-bold">Total</td>
            <td
              :key="header.value + 'cc'"
              class="font-weight-bold"
              v-for="header in filteredHeaders"
            >
              {{ header.computed(summary) }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
let currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

export default {
  name: "Provinces-Report",
  props: ["type", "label"],
  data: () => ({
    items: [],
    loading: false,
    programAreas: [],
    selectedAreas: [],
    end_date: new Date().toISOString().substring(0, 10),
    start_date: currentDate.toISOString().substring(0, 10)
  }),

  computed: {
    filteredHeaders() {
      let items =
        this.selectedAreas.length > 0 ? this.selectedAreas : this.programAreas;
      return items.map(item => ({
        width: "40px",
        text: item.name,
        value: item.name,
        computed: cso => Number(cso[item.name])
      }));
    },

    headers() {
      let items = [{ text: "CSOs Name", value: "name" }];
      items.push(...this.filteredHeaders);
      return items;
    },

    filteredItems() {
      if (this.selectedAreas.length < 1) return this.items;
      return this.items.filter(item =>
        this.selectedAreas.some(field => item[field.name])
      );
    },

    summary() {
      let data = { name: "Total", programs: [] };
      this.programAreas.forEach(item => {
        data[item.name] = this.filteredItems.filter(x => x[item.name]).length;
      });
      return data;
    }
  },

  methods: {
    async getData() {
      this.loading = true;
      await this.axios.get("program-areas").then(res => {
        this.programAreas = res.data.data.filter(x => x.type == this.type);
      });

      await this.axios
        .get(`reports?analytical-status=true`)
        .then(res => {
          this.items = res.data;
          this.loading = false;
        })
        .catch(vm => (vm.loading = false));
    },

    printTable(excel) {
      let items = [...this.filteredItems];
      items.push(this.summary);
      let data = {
        items: items,
        landscape: true,
        headers: this.headers,
        title: this.$t(this.label)
      };

      if (excel) return this.xl_tables(data, "Analytical - Status Report");
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    }
  },
  created() {
    this.getData();
  }
};
</script>
